(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------------------------------------------------------------
     DINERO
  --------------------------------------------------------------------- */
  function formatMoney(cents) {
    var format = window.themeMoneyFormat || 'S/ {{amount}}';
    var value = (Number(cents) / 100);
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ---------------------------------------------------------------------
     DRAWERS (menú, búsqueda, carrito) — delegación de eventos para que
     funcionen también después de refrescar el carrito
  --------------------------------------------------------------------- */
  function openDrawer(name) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer) return false;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var focusable = drawer.querySelector('input, button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    return true;
  }
  function closeAllDrawers() {
    document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-drawer-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeAllDrawers();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  /* ---------------------------------------------------------------------
     CARRITO (Ajax API + Section Rendering API)
  --------------------------------------------------------------------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.classList.contains('site-header__cart-count')) el.hidden = count === 0;
    });
  }

  function refreshCartDrawer() {
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-panel]');
        var current = document.querySelector('[data-cart-drawer-panel]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function afterCartChange(cart, open) {
    updateCartCount(cart.item_count);
    return refreshCartDrawer().then(function () {
      if (open) openDrawer('cart');
      return cart;
    });
  }

  function addToCart(variantId, quantity) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          return data;
        });
      })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { return afterCartChange(cart, true); });
  }

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, quantity) })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { return afterCartChange(cart, false); });
  }

  /* Botones + / − / quitar dentro del carrito lateral */
  document.addEventListener('click', function (e) {
    var changeBtn = e.target.closest('[data-cart-qty-change]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!changeBtn && !removeBtn) return;
    var lineEl = e.target.closest('[data-cart-line]');
    if (!lineEl) return;
    e.preventDefault();
    var line = lineEl.getAttribute('data-cart-line');
    if (removeBtn) return changeLine(line, 0);
    var input = lineEl.querySelector('[data-cart-qty-input]');
    var qty = parseInt(input.value || '0', 10) + parseInt(changeBtn.getAttribute('data-cart-qty-change'), 10);
    changeLine(line, qty);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty-input]')) return;
    var lineEl = e.target.closest('[data-cart-line]');
    if (lineEl) changeLine(lineEl.getAttribute('data-cart-line'), parseInt(e.target.value || '0', 10));
  });

  /* Agregar rápido desde tarjetas de producto */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Agregando...';
    addToCart(variantId, 1)
      .catch(function (err) { alert(err.message); })
      .then(function () { btn.disabled = false; btn.innerHTML = original; });
  });

  /* ---------------------------------------------------------------------
     PÁGINA DE PRODUCTO: variantes, cantidad, galería
  --------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    var form = section.querySelector('[data-product-form], #product-form');
    var jsonEl = section.querySelector('[data-product-json]');
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (err) { product = null; }

    var idInput = form && form.querySelector('[data-variant-id-input]');
    var addBtn = form && form.querySelector('[data-add-to-cart-btn]');
    var addText = form && form.querySelector('[data-add-to-cart-text]');
    var priceEl = section.querySelector('[data-product-price]');

    function selectedOptions() {
      var values = [];
      section.querySelectorAll('.product-form__option').forEach(function (group, i) {
        var sel = group.querySelector('.option-pill[data-selected="true"]');
        values[i] = sel ? sel.getAttribute('data-value') : null;
      });
      return values;
    }

    function findVariant(values) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return values[i] == null || opt === values[i]; });
      }) || null;
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var found = false;
      section.querySelectorAll('.product-page__gallery-item').forEach(function (item) {
        var active = item.getAttribute('data-media-id') == mediaId;
        if (active) found = true;
        item.setAttribute('data-active', active ? 'true' : 'false');
      });
      if (!found) return;
      section.querySelectorAll('[data-thumb-media]').forEach(function (t) {
        t.setAttribute('data-active', t.getAttribute('data-thumb-media') == mediaId ? 'true' : 'false');
      });
    }

    function renderVariant(variant) {
      if (!addBtn) return;
      if (!variant) {
        addBtn.disabled = true;
        addText.textContent = 'No disponible';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addText.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceEl.innerHTML = '<span class="price__regular">' + formatMoney(variant.price) + '</span>';
        }
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    section.querySelectorAll('.option-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('.product-form__option');
        group.querySelectorAll('.option-pill').forEach(function (p) { p.setAttribute('data-selected', 'false'); });
        pill.setAttribute('data-selected', 'true');
        var label = group.querySelector('[data-option-label]');
        if (label) label.textContent = pill.getAttribute('data-value');
        renderVariant(findVariant(selectedOptions()));
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        var qtyInput = form.querySelector('input[name="quantity"]');
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;
        var original = addText.textContent;
        addBtn.disabled = true;
        addText.textContent = 'Agregando...';
        addToCart(idInput.value, qty)
          .catch(function (err) { alert(err.message); })
          .then(function () { addBtn.disabled = false; addText.textContent = original; });
      });

      form.querySelectorAll('[data-qty-increase], [data-qty-decrease]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = form.querySelector('input[name="quantity"]');
          var step = btn.hasAttribute('data-qty-increase') ? 1 : -1;
          input.value = Math.max(1, parseInt(input.value || '1', 10) + step);
        });
      });
    }

    section.querySelectorAll('[data-thumb-media]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-thumb-media')); });
    });
  });

  /* ---------------------------------------------------------------------
     BÚSQUEDA PREDICTIVA
  --------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    var searchInput = document.querySelector('[data-predictive-search-input]');
    var searchResults = document.querySelector('[data-predictive-search-results]');
    if (!searchInput || !searchResults) return;
    var timer;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var term = searchInput.value.trim();
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { searchResults.innerHTML = '<p>Sin resultados.</p>'; return; }
            searchResults.innerHTML = '<div class="product-grid">' + products.map(function (p) {
              var price = String(p.price).indexOf('.') > -1 ? formatMoney(Math.round(parseFloat(p.price) * 100)) : esc(p.price);
              return '<a class="product-card" href="' + esc(p.url) + '">' +
                '<div class="product-card__media">' +
                (p.image ? '<img class="product-card__image" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
                '</div>' +
                '<div class="product-card__info"><span class="product-card__title">' + esc(p.title) + '</span>' +
                '<span class="price"><span class="price__regular">' + price + '</span></span></div>' +
                '</a>';
            }).join('') + '</div>';
          })
          .catch(function () {});
      }, 250);
    });
  });
})();
